import {
  CarrierVolumeOverTimeRequestSchema,
  CarrierVolumeOverTimeResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getCarrierVolumeOverTime = {
  name: "getCarrierVolumeOverTime" as const,
  input: CarrierVolumeOverTimeRequestSchema,
  output: CarrierVolumeOverTimeResponseSchema,
};
